<template>
  <card class="form-card">
    <template slot="header">
      <div class="form-title">{{ title }}</div>
      <div class="form-explainer">
        {{ explainer }}
      </div>
      <div class="error" v-if="error != ''">{{ error }}</div>
    </template>
    <template>
      <div class="row justify-content-center last-input">
        <div class="col">
          <fg-input type="email"
                    label="Email"
                    v-model="email">
          </fg-input>
        </div>
      </div>
      <div class="row justify-content-center">
        <default-button :buttonText="request_reset" :processing-click="requesting_reset" v-on:onButtonClicked="requestReset" />
      </div>
    </template>
  </card>
</template>
  
<script>
  import Card from '@/components/UIComponents/Cards/Card.vue'
  import DefaultButton from '@/components/UIComponents/Buttons/DefaultButton.vue'
  import axios from 'axios'

  export default {
    components: {
      Card,
      DefaultButton,
    },
    data: function () {
      return {
        title: "Password Reset",
        explainer: "Enter your email below and we'll send you instructions to reset your password.",
        email: "",
        request_reset: "REQUEST RESET",
        requesting_reset: false,
        error: "",
        email_regex: /\S+@\S+\.\S+/,
      }
    },
    methods: {
      async requestReset() {
        if (this.email_regex.test(this.email)) {
          if (!this.requesting_reset) {
            this.requesting_reset = true
            const payload = {
              email: this.email,
            }

            await axios.post(this.$store.state.endpoints.passwordReset, payload)
              .then((response)=>{
                this.$router.push('password_reset/done')
              })
              .catch((error)=>{
                // eslint-disable-next-line
                console.log(error);
                this.requesting_reset = false;
              }) 
          }
        } else {
          this.error = 'Please enter a valid email address';
        }
      },
    },
  }
</script>
